import { Typography, Box } from '@mui/material';
import React, { useEffect } from 'react';
import { useSettingsContext } from '../context/SettingsContext';
import { useParams } from 'react-router-dom';
import RolesAndPermissions from './RolesAndPermissions/RolesAndPermissions';
import { RolesPermissionsProvider } from '../context/RolesAndPermissionsContext';
import Integrations from 'application/routes/settings/components/Integrations/Integrations';
import AIPrompts from './AIPrompts/AIPrompts';
import DocuSealVisibility from './DocuSealVisibility/DocuSealVisibility';
import OrgConfig from './Configuration/OrgConfig.view';
import GeneralOrgConfig from './Configuration/GeneralOrgConfig.view';
import CompanyInformation from './CompanyInformation/CompanyInformation';
import CustomerFacingProfile from './CustomerFacingProfile/CustomerFacingProfile';
import useOrgData from '../../../hooks/useOrgData';

const SettingsContainer = () => {
  const { selectedSetting, setSelectedSetting } = useSettingsContext();
  const { setting } = useParams<{ setting: string }>(); // Get the current setting from the URL params

  // Initialize org data when user navigates to settings
  const { orgData } = useOrgData();

  useEffect(() => {
    if (setting) {
      setSelectedSetting(setting as any);
    }
  }, [setting, setSelectedSetting]);

  const renderSetting = () => {
    switch (selectedSetting) {
      case 'general':
        return <GeneralOrgConfig />;
      case 'company':
        return <CompanyInformation />;
      case 'customer-profile':
        return <CustomerFacingProfile />;
      case 'roles':
        return (
          <RolesPermissionsProvider>
            <RolesAndPermissions />
          </RolesPermissionsProvider>
        );

      case 'integrations':
        return <Integrations />;

      case 'ai':
        return <AIPrompts />;
      case 'config':
        return <OrgConfig />;

      case 'deals':
        return (
          <Typography style={{ color: 'red' }}>
            Deals and Properties Settings
          </Typography>
        );
      case 'hierarchy':
        return (
          <Typography style={{ color: 'red' }}>Hierarchy Settings</Typography>
        );
      case 'docuseal':
        return <DocuSealVisibility orgData={orgData} />;
      default:
        return (
          <Typography style={{ color: 'red' }}>
            Select a setting from the sidebar
          </Typography>
        );
    }
  };

  return <Box sx={{ mt: 17, mx: 4, flexGrow: 1 }}>{renderSetting()}</Box>;
};

export { SettingsContainer };
